var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumerableSymbolWhiteOnTransparentLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "symbol",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "43.375px",
    height: "36.75px",
    viewBox: "0 0 43.375 36.75",
    enableBackground: "new 0 0 43.375 36.75",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M40.081,5.606c-1.145,0-2.073,0.928-2.073,2.073v16.829c0,3.92-3.19,7.11-7.111,7.11 c-3.921,0-7.111-3.19-7.111-7.11V12.36c0-6.207-5.05-11.257-11.258-11.257S1.271,6.153,1.271,12.36v16.829 c0,1.145,0.928,2.073,2.073,2.073s2.073-0.928,2.073-2.073V12.36c0-3.92,3.19-7.11,7.111-7.11s7.111,3.19,7.111,7.11v12.148 c0,6.207,5.05,11.257,11.258,11.257s11.258-5.05,11.258-11.257V7.68C42.155,6.535,41.227,5.606,40.081,5.606z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumerableSymbolWhiteOnTransparentLink);
export default __webpack_public_path__ + "static/media/numerable_symbol_white_on_transparent_link.5453b79f6d78e65c0b71fde8dfa80e64.svg";
export { ForwardRef as ReactComponent };